import AppRoute from "models/AppRoute"

const InventoryRoute = new AppRoute({
    route: "/inventory",
    navbar: true,
    authRequired: true,
})

export default InventoryRoute
